/**
 * Checkout document slice (RTK). Same state shape as reducer-CheckoutDocument.
 */
import { createSlice } from "@reduxjs/toolkit";
import { DATA_LOAD_STATUS, DOCUMENT_LOAD_STATUS } from "../../constants/metaData";
import { getPayloadValue } from "../../../functions/reduxMethod";

const initialState = {
  "@odata.context": null,
  downloadData: "",
  oneDriveUploadStatus: DATA_LOAD_STATUS.onStart,
  oneDriveUploadFiles: [],
  checkoutDocument: null,
  checkoutDocumentStatus: DOCUMENT_LOAD_STATUS.onStart,
};

const checkoutSlice = createSlice({
  name: "checkoutDocument",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase("ON_FILE_DOWNLOAD", (state, action) => {
        state.downloadData = action.payload;
      })
      .addCase("ON_UPLOAD_ONEDRIVE_FILES", (state, action) => {
        state.oneDriveUploadFiles = action.payload;
      })
      .addCase("ON_UPLOAD_ONEDRIVE_STATUS_CHANGED", (state, action) => {
        state.oneDriveUploadStatus = action.payload;
      })
      .addCase("ON_CHECKOUT_DOCUMENT_CHANGE", (state, action) => {
        state.checkoutDocument = getPayloadValue(action.payload, null);
      })
      .addCase("ON_CHECKOUT_DOCUMENT_STATUS_CHANGE", (state, action) => {
        state.checkoutDocumentStatus = getPayloadValue(
          action.payload,
          DOCUMENT_LOAD_STATUS.onStart
        );
      });
  },
});

export default checkoutSlice;
